export enum QueryStatus {
  Idle = 'idle',
  Loading = 'loading',
  Pending = 'pending',
  Error = 'error',
  Success = 'success',
}

export enum FetchStatus {
  Fetching = 'fetching',
  Paused = 'paused',
  Idle = 'idle',
}
